import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import { useSelector, useDispatch } from 'react-redux';
import {
  clearTutorMatchingData,
  getSubjectsUnderEnrollmentId,
  getTutorMatchCroFilterOptions,
  getUnMappedStudentUnderCro,
} from '../../../../redux/features/CRDslice';
import TutorMatchPanel from './TutorMatchPanel';

// CRD Tutor Match Making: pick a student and subject, then the shared TutorMatchPanel (also used by the retention
// workspace's stage 4) searches and assigns.
const FindMyTutorCardsLanding = () => {
  const dispatch = useDispatch();

  const loading = useSelector((store) => store.crd.loading);
  const unMappedStudent = useSelector((store) => store.crd.unMappedStudent);
  const subjects = useSelector((store) => store.crd.subjects);
  const croFilter = useSelector((store) => store.crd.tutorMatchCroFilter);

  const [cro, setCro] = useState(null);
  const [courseEnrollmentId, setCourseEnrollmentId] = useState(null);
  const [subjectEnrollmentId, setsubjectEnrollmentId] = useState(null);

  // CRO filter is only rendered for Talent Acquisitions wing users
  useEffect(() => {
    const thunkAPI = dispatch(getTutorMatchCroFilterOptions());
    return () => {
      thunkAPI.abort();
    };
  }, [dispatch]);

  useEffect(() => {
    const thunkAPI = dispatch(getUnMappedStudentUnderCro(cro?.userID ?? null));
    return () => {
      thunkAPI.abort();
    };
  }, [cro, dispatch]);

  useEffect(() => {
    setsubjectEnrollmentId(null);
    dispatch(clearTutorMatchingData());
    if (courseEnrollmentId) {
      const thunkAPI = dispatch(getSubjectsUnderEnrollmentId(courseEnrollmentId));

      return () => {
        thunkAPI.abort();
      };
    }
  }, [courseEnrollmentId, dispatch]);

  // the filter row holds 2 fields normally, 3 once the CRO filter is available
  const filterGridSize = croFilter?.showCroFilter ? 4 : 6;

  return (
    <GlobalWrapper title={'Tutor Match Making'}>
      {/* ================= FILTER SECTION ================= */}
      <Paper
        elevation={0}
        sx={{ p: 3, borderRadius: 4, mb: 4, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}
      >
        <Grid container spacing={3} alignItems="flex-start">
          {/* ---------- CRO FILTER (Talent Acquisitions wing only) ---------- */}
          {croFilter?.showCroFilter && (
            <Grid item xs={12} md={filterGridSize}>
              <Autocomplete
                disabled={croFilter?.loading}
                fullWidth
                options={croFilter?.cros || []}
                getOptionLabel={(option) => option?.name || ''}
                isOptionEqualToValue={(opt, val) => val?.userID === opt?.userID}
                renderOption={(props, opt) => (
                  <li {...props} key={opt?.userID}>
                    {opt?.name || ''}
                  </li>
                )}
                value={cro}
                onChange={(e, option) => {
                  setCro(option || null);
                  // student / subject selections belong to the previous CRO
                  setCourseEnrollmentId(null);
                  setsubjectEnrollmentId(null);
                  dispatch(clearTutorMatchingData());
                }}
                renderInput={(params) => <TextField {...params} label="CRO" variant="outlined" />}
              />
            </Grid>
          )}

          <Grid item xs={12} md={filterGridSize}>
            <Autocomplete
              disabled={loading}
              fullWidth
              options={unMappedStudent || []}
              getOptionLabel={(option) => option?.student_name || ''}
              isOptionEqualToValue={(opt, val) => val?.course_enrollment_id === opt?.course_enrollment_id}
              renderOption={(props, opt) => (
                <li {...props} key={opt?.course_enrollment_id}>
                  {opt?.student_name || ''}
                </li>
              )}
              value={unMappedStudent?.find((data) => data?.course_enrollment_id === courseEnrollmentId) || null}
              onChange={(e, option) => {
                setCourseEnrollmentId(option ? option.course_enrollment_id : null);
              }}
              renderInput={(params) => <TextField {...params} label="Search Student" variant="outlined" />}
            />
          </Grid>

          <Grid item xs={12} md={filterGridSize}>
            <Autocomplete
              disabled={loading}
              fullWidth
              options={subjects || []}
              getOptionLabel={(option) => option?.subject_name || ''}
              isOptionEqualToValue={(opt, val) => val?.subject_enrollment_id === opt?.subject_enrollment_id}
              renderOption={(props, opt) => (
                <li {...props} key={opt?.subject_enrollment_id}>
                  {opt?.subject_name || ''}
                </li>
              )}
              value={subjects?.find((data) => data?.subject_enrollment_id === subjectEnrollmentId) || null}
              onChange={(e, option) => {
                setsubjectEnrollmentId(option?.subject_enrollment_id);
              }}
              renderInput={(params) => <TextField {...params} label="Subject" variant="outlined" />}
            />
          </Grid>
        </Grid>
      </Paper>

      <TutorMatchPanel courseEnrollmentId={courseEnrollmentId} subjectEnrollmentId={subjectEnrollmentId} />
    </GlobalWrapper>
  );
};

export default FindMyTutorCardsLanding;
